module.exports = __webpack_public_path__ + "static/media/google-logo.36158af3.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/google-logo.png
// module id = 15
// module chunks = 0